<template>
	<div class="wrapper organization-page">
		<!-- Header -->
		<Header />
		<!-- HeaderMenu -->
		<HeaderMenu />

		<div class="contents">
			<div class="layout">
				<div class="left">
					<div class="pc-only">
						<Sidebar />
					</div>
				</div>
				<div class="right">
					<h1>組織図</h1>
					<div class="table">
						<div class="search-area">
							<p>{{ $t("Your Organization") }}</p>
							<div class="search-box" :class="{'active': active}">
								<input type="text" name="" id="search" class="search-input">
								<span v-on:click="toggleAction">
									<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
										<defs>
											<clipPath id="clip-path">
											<rect data-name="357" width="20" height="20" transform="translate(1383 173)" fill="#fff" stroke="#707070" stroke-width="1"/>
											</clipPath>
										</defs>
										<g data-name="44" transform="translate(-1383 -173)" clip-path="url(#clip-path)">
											<path id="magnifying-glass" d="M14.677,12.91a8.155,8.155,0,1,0-1.767,1.768L18.232,20,20,18.232,14.677,12.91Zm-6.552.841A5.625,5.625,0,1,1,13.75,8.125,5.631,5.631,0,0,1,8.125,13.75Z" transform="translate(1383 173)" fill="#fff"/>
										</g>
									</svg>
								</span>
							</div>
						</div>
						<ul class="list">
							<li>{{ $t("USER NAME") }}</li>
							<li>{{ $t("AMOUNT") }}</li>
							<li>{{ $t("REFERRALS") }}</li>
							<li>{{ $t("PACKAGE") }}</li>
						</ul>
						<ul class="list" v-for="user in users" v-bind:key="user.id">
							<li :class="{'isActive' :user.referrals > 0}">
								<router-link to="/organization/user1">
									{{user.name}}
								</router-link>
								</li>
							<li :class="{'isActive' :user.referrals > 0}">
								<router-link to="/organization/user1">
									{{user.amount}}
								</router-link>
							</li>
							<li :class="{'isActive' :user.referrals > 0}">
								<router-link to="/organization/user1">
									{{user.referrals}}
								</router-link>
							</li>
							<li :class="{'isActive' :user.referrals > 0}">
								<router-link to="/organization/user1">
									{{user.stage}}
								</router-link>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<!-- /.contents -->

		<Footer title="Organization"/>
	</div>
</template>
<style scoped>
</style>
<script>
import Header from "@/components/Header.vue";
import HeaderMenu from "@/components/HeaderMenu.vue";
import Sidebar from "@/components/Sidebar.vue";
import Footer from "@/components/Footer.vue";
export default {
	name: "Organization",
	 components: {
		Header,
		HeaderMenu,
		Sidebar,
		Footer
	},
	data: () => {
		return {
			title: "Organization",
			active: false,
			users: [
				{
					id: 1,
					name: "USER1",
					amount: "1,000",
					referrals: "1",
					stage: 3,
				},
				{
					id: 2,
					name: "USER2",
					amount: "1,000",
					referrals: "3",
					stage: 5,
				},
				{
					id: 3,
					name: "USER3",
					amount: "1,000",
					referrals: "0",
					stage: 1,
				},
				{
					id: 4,
					name: "USER4",
					amount: "1,000",
					referrals: "1",
					stage: 2,
				},
				{
					id: 5,
					name: "USER5",
					amount: "1,000",
					referrals: "1",
					stage: 3,
				},
				{
					id: 6,
					name: "USER6",
					amount: "1,000",
					referrals: "3",
					stage: 5,
				},
				{
					id: 7,
					name: "USER7",
					amount: "1,000",
					referrals: "0",
					stage: 1,
				},
				{
					id: 8,
					name: "USER8",
					amount: "1,000",
					referrals: "0",
					stage: 2,
				},
			],
		};
	},
	methods: {
		toggleAction () {
			this.active = !this.active
		}
	},
	computed: {

	},
	mounted: function() {
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty("--vh", vh + "px");

		var ua = navigator.userAgent.toLowerCase();
		var isiOS = ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1;
		if (isiOS) {
			var viewport = document.querySelector('meta[name="viewport"]');
			if (viewport) {
				var viewportContent = viewport.getAttribute("content");
				viewport.setAttribute(
					"content",
					viewportContent + ", user-scalable=no"
				);
			}
		}
	},
};
</script>
